import { Outlet } from "react-router";
import { useTranslations } from "use-intl";
import { Link } from "@/i18n/navigation";
import { LocaleSwitcher } from "@/components/shared/locale-switcher";
import { CheckCircle2 } from "lucide-react";
import { LogoMark } from "@/components/shared/logo-mark";

const BENEFIT_KEYS = ["item1", "item2", "item3"] as const;

export function AuthLayout() {
  const t = useTranslations("auth");
  const tc = useTranslations("common");

  return (
    <div className="flex min-h-full flex-1">
      {/* Branding panel — hidden on small screens, not just shrunk (the
          benefit checklist and illustration wouldn't read well below
          lg width, so it's removed rather than squeezed). */}
      <aside className="examora-hero-glow relative hidden w-1/2 flex-col justify-between overflow-hidden border-r border-border bg-card p-12 lg:flex">
        <Link href="/" className="flex items-center gap-2 text-lg font-semibold tracking-tight">
          <LogoMark className="h-7 w-7" />
          {tc("appName")}
        </Link>

        <div className="flex flex-col gap-6">
          <h2 className="max-w-sm text-3xl font-semibold leading-tight tracking-tight">
            {t("register.subtitle")}
          </h2>
          <ul className="flex flex-col gap-3">
            {BENEFIT_KEYS.map((key) => (
              <li key={key} className="flex items-center gap-2.5 text-sm text-muted-foreground">
                <CheckCircle2 className="h-4 w-4 shrink-0 text-success" aria-hidden="true" />
                {t(`benefits.${key}`)}
              </li>
            ))}
          </ul>
        </div>

        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} {tc("appName")}
        </p>
      </aside>

      <div className="flex flex-1 flex-col">
        <header className="flex items-center justify-between px-6 py-5 lg:justify-end">
          <Link
            href="/"
            className="flex items-center gap-2 text-base font-semibold tracking-tight lg:hidden"
          >
            <LogoMark className="h-6 w-6" />
            {tc("appName")}
          </Link>
          <LocaleSwitcher />
        </header>

        <main className="flex flex-1 flex-col items-center justify-center px-6 py-8">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
